import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";


export function CurrencyForm() {
    const { isFormDisabled, form } = useFieldFormContext();
    return (
        <div className="flex flex-col gap-2">
            <FormField
                name="field_min"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Minimum value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            >

            </FormField>
            <FormField
                name="field_max"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Maximum value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            >
            </FormField>
            <FormField
                name="field_integer_places"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Maximum number of integer digits</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            >
            </FormField>
            <FormField
                name="field_decimal_places"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Maximum number of decimal digits</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            >
            </FormField>
        </div>
    )
}